import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Check, UserMinus, UserPlus, Mail, Trash2, X, MoreHorizontal } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface UsersBulkActionsToolbarProps {
  selectedCount: number;
  totalCount: number;
  onClearSelection: () => void;
  onApprove: () => void;
  onActivate: () => void;
  onDeactivate: () => void;
  onInvite: () => void;
  onDelete: () => void;
}

export function UsersBulkActionsToolbar({
  selectedCount,
  totalCount,
  onClearSelection,
  onApprove,
  onActivate,
  onDeactivate,
  onInvite,
  onDelete,
}: UsersBulkActionsToolbarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-md px-3 py-2 mb-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Badge variant="secondary" className="bg-primary/15 text-primary text-xs">
            {selectedCount} of {totalCount} selected
          </Badge>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="h-7 px-2 text-xs text-muted-foreground hover:text-foreground"
          >
            <X className="h-3 w-3 mr-1" />
            Clear
          </Button>
        </div>

        <div className="flex items-center gap-1">
          <Button
            variant="outline"
            size="sm"
            onClick={onApprove}
            className="h-7 px-2 text-xs gap-1"
          >
            <Check className="h-3 w-3" />
            Approve
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onActivate}
            className="h-7 px-2 text-xs gap-1"
          >
            <UserPlus className="h-3 w-3" />
            Activate
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onDeactivate}
            className="h-7 px-2 text-xs gap-1"
          >
            <UserMinus className="h-3 w-3" />
            Deactivate
          </Button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="sm" className="h-7 px-2 text-xs gap-1">
                <MoreHorizontal className="h-3 w-3" />
                More
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={onInvite}>
                <Mail className="h-4 w-4 mr-2" />
                Invite / Resend
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onDelete} className="text-destructive focus:text-destructive">
                <Trash2 className="h-4 w-4 mr-2" />
                Delete
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
}
